import { store as notificationStore } from 'react-notifications-component'
import _ from 'lodash'
import moment from 'moment'
import store from '../../utils/store'
import {
  API_ORDER_PREPARING_UPDATE,
  API_SEND_ORDER_TO_DRIVERS,
  DRIVER_CANCEL_REASSIGNMENT,
  ERROR_ADD_TIME_TO_ORDER,
  ERROR_CHECKING_ORDER,
  ERROR_PUSH_ORDER_TO_DRIVER,
  NO_AVAILABLE_DRIVER,
  ORDER_REFUND,
  ORDER_REFUND_LABEL,
  ORDER_TYPE_DELIVERY,
  PRINTER_TYPE_CLOUDPRINT,
  PRINTER_TYPE_EPSON,
  PRINTER_TYPE_QZ,
  RECORD_INVALID,
  STRIPE,
  SUCCESS_UPDATE_TEXT, EXTERNAL_DELIVERY_PROVIDERS, ITEM_KEY_CATEGORY_SEPARATOR, ITEM_KEY_COUNTER_SEPARATOR,
  ORDER_CANCELED_LABEL, STUART, UBER, DELIVEROO, ORDER_PHASE_LOOKING_FOR_DRIVER_LABEL, ORDER_FLOW_TYPE, PICKUP_STATUS_KEY, ORDER_PHASE_PREPARING_LABEL, SPLASH, ORDER_SYNCH_TOPOS
} from '../../constants'
import { getIdToken } from '../../apis/firebase'
import { mooveOrderToCancel, mooveOrderToCook, refundOrder, printOrdersCreate, mooveOrderToTakeAway, mooveOrderToPastOrder, lunchDelivery, acceptDelivery } from '../../apis/backend'
import { sendPostRequest } from '../../utils/apiService'
import { showNotification } from '../Notification/Notification.view'
import { checkAccess } from '../../utils/admins'
import { isStringNotNull } from '../../utils/tools'
import { checkIntegrationAccess, hasExternalIntegration, getOpenTimerSendToPOS } from 'src/utils/externalIntegration';
import fleet from '../../assets/pictures/fleet.png';
import stuartLogo from '../../assets/pictures/stuartLogo.png';
import delivero from '../../assets/pictures/delivero.png';
import uberDirectLogo from '../../assets/pictures/uberDirectLogo.png';
import { subtractFromDate, displayDate, suitableTime } from '../../utils/suitableDate';
const setIntervalSong = null;

export const printTicket = async (component, order, feedback) => {
  const hour = currentHours(component);
  const { shop = {} } = store.getState().firebaseRealTime;
  const { support = {} } = shop;
  const { number } = support;
  const { dashboardConfig, printers, shopId } = store.getState().user;
  const { printer } = dashboardConfig;
  const { chargeId, id } = order;

  // Default use QZ
  let printerType = PRINTER_TYPE_QZ;
  let printerToUse = printers;
  let result = false;
  if (printer) {
    const { type, printerUrl } = printer;
    printerType = type;
    printerToUse = `http://${printerUrl}/StarWebPRNT/SendMessage`;
  }

  const returnOrder = _.cloneDeep(order);
  const { dateSent, date, datePreparationEnded } = returnOrder;
  returnOrder.date = moment(dateSent || date).format();
  returnOrder.datePreparationEnded = moment(datePreparationEnded).format();
  if (printer && printer.enabled && (printerType === PRINTER_TYPE_CLOUDPRINT)) {
    await printOrdersCreate(id, chargeId, returnOrder)
    result = true
  } else if ((printer && printer.enabled) || !printer) {
    if (printerType === PRINTER_TYPE_EPSON && window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'print', value: returnOrder, printerIp: printer?.printerUrl }));
    } else {
      result = await window.printTicket(
        printerType,
        printerToUse,
        order,
        shopId,
        hour,
        number,
        feedback
      );
    }
  }
  if (result && feedback) {
    notificationStore.addNotification({
      message: "L'impression a bien été envoyée à l'imprimante !",
      type: 'info',
      insert: 'top',
      container: 'bottom-right',
      animationIn: ['animated', 'fadeIn'],
      animationOut: ['animated', 'fadeOut'],
      dismiss: {
        duration: 3000
      }
    });
  }
};

export const handleNewOrder = async (component, order, preparationTime) => {
  const { openErrorModal } = component.props;
  try {
    clearIntervalSong();
    component.setState({ isLoadingReception: true });
    const returnPreparationTime = parseInt(preparationTime, 10);
    await mooveOrderToCook(order, returnPreparationTime, 'Commande envoyée avec succès pour préparation');
    component.setState({ isLoadingReception: false });
  } catch (error) {
    component.setState({ isLoadingReception: false });
    switch (error) {
      case ERROR_CHECKING_ORDER:
        return openErrorModal(
          'Le client est en train de modifier ou annuler sa commande, merci de réessayer !'
        );
      case RECORD_INVALID:
        switch (preparationTime) {
          case 15:
            return openErrorModal(
              'Un problème est survenu avec le service Stuart, merci de réessayer !'
            );
          default:
            return openErrorModal(
              'Le service de livraison Stuart va bientôt fermer, merci de sélectionner un temps de préparation plus court ou de refuser la commande'
            );
        }
      default:
        return openErrorModal('Un problème est survenu, merci de réessayer !');
    }
  }
  return true;
};

export const pushOrdersToDrivers = async (component, order) => {
  const {
    openErrorModal,
    driversAvailability = {},
    isAllShops
  } = component.props;
  const { nbDriversFreelance, nbDriversAvailable } = driversAvailability;
  const { isLoadingSendingOrder } = component.state;
  const { shopId, id: customerId } = order;
  if (isLoadingSendingOrder) return;
  component.setState({ isLoadingSendingOrder: true });
  if (!nbDriversAvailable && !nbDriversFreelance && !order?.stuart && !order?.deliveroo && !isAllShops) {
    openErrorModal(NO_AVAILABLE_DRIVER);
  } else {
    try {
      await sendPostRequest(
        API_SEND_ORDER_TO_DRIVERS,
        {
          customerId,
          shopId,
          chargeId: order.chargeId
        },
        {}
      );

    } catch (error) {
      openErrorModal(ERROR_PUSH_ORDER_TO_DRIVER);
    }
    finally {
      component.setState({ isLoadingSendingOrder: false });
      showNotification(
        'light',
        'ltr',
        'primary',
        'Envoi réussi',
        'La commande a bien été envoyée !'
      );
    }
  }
};

export const addTimeToPreparationTime = async (component, order) => {
  const { openErrorModal } = component.props;
  const { id: customerId, preparationTime = 15 } = order;
  try {
    await sendPostRequest(
      API_ORDER_PREPARING_UPDATE,
      {
        customerId,
        preparationTime: parseInt(preparationTime, 10) + 15,
        chargeId: order.chargeId
      },
      {}
    );
    showNotification(
      'light',
      'ltr',
      'primary',
      SUCCESS_UPDATE_TEXT,
      'Les 15 minutes ont bien été ajoutées !'
    );
  } catch (error) {
    openErrorModal(ERROR_ADD_TIME_TO_ORDER);
  }
};

export const changePreparationTime = (component, valueToAdd) => {
  component.setState(prevState => {
    const { valuePreparationTime: value } = prevState;
    const valueToReturn = value + valueToAdd;
    return { valuePreparationTime: valueToReturn < 0 ? 0 : valueToReturn };
  });
};

export const handleOrderReady = async (order, component) => {
  const { openErrorModal } = component.props;
  component.setState({ isLoadingReception: true });
  try {
    await mooveOrderToTakeAway(order);
  } catch (error) {
    openErrorModal(
      'Le client est en train de modifier ou annuler sa commande, merci de patienter !'
    );
  }
  component.setState({ isLoadingReception: false });
};

export const handleCustomerTakesOrder = async (order, component) => {
  const { openErrorModal, handleClose } = component.props;

  component.setState({ isLoadingReception: true });
  try {
    await mooveOrderToPastOrder(order);
  } catch (error) {
    openErrorModal(
      'Le client est en train de modifier ou annuler sa commande, merci de patienter !'
    );
  }
  component.setState({ isLoadingReception: false });
  handleClose();
};

export const canRefundOrder = (order, component) => {
  const { marketplace, distributeurAdmin } = component.props;
  const { paymentType, date, shopId } = order;
  const refundDateLimit = moment(date).add(distributeurAdmin ? 30 : 7, 'days');
  return (
    !checkIntegrationAccess('order', 'cannotRefundOrder', shopId) &&
    paymentType === STRIPE &&
    checkAccess('features', 'refundOrder') &&
    !marketplace &&
    moment().isBefore(refundDateLimit)
  );
};


export const handleCancelOrder = async (order, component, cancelReason) => {
  const { openErrorModal, driversAvailability = {}, isAllShops, showModal, handleClose } = component.props;
  const { nbDriversFreelance, nbDriversAvailable } = driversAvailability;
  const isDriverReassignment = cancelReason === DRIVER_CANCEL_REASSIGNMENT;
  const hasNoDrivers = !nbDriversAvailable && !nbDriversFreelance;
  const hasNoExternalDelivery = !order?.stuart && !order?.deliveroo && !order?.uberDirect;

  if (isDriverReassignment && hasNoDrivers && hasNoExternalDelivery && !isAllShops) {
    openErrorModal(NO_AVAILABLE_DRIVER);
    return;
  }
  else {
    component.setState({ isLoadingReception: cancelReason !== DRIVER_CANCEL_REASSIGNMENT, isLoadingDriver: cancelReason === DRIVER_CANCEL_REASSIGNMENT });
    try {
      await mooveOrderToCancel(order, cancelReason);
    } catch (err) {
      const modalData = {
        color: 'danger',
        btnColor: 'danger',
        title: 'Le client est en train de modifier ou annuler sa commande, merci de patienter !'
      };
      showModal(modalData);
    }
  }

  component.setState({ isLoadingReception: false, isLoadingDriver: false });
  cancelReason !== DRIVER_CANCEL_REASSIGNMENT && handleClose();
};

export const handleRefundOrder = async (order, isPastOrder, component) => {
  try {
    component.setState({ isLoadingReception: true });
    await refundOrder(order, isPastOrder);
    component.props.refundOrder({
      ...order,
      status: ORDER_REFUND,
      statusLabel: ORDER_REFUND_LABEL
    });
  } catch (err) {
    const { showModal } = component.props;
    const modalData = {
      color: 'danger',
      btnColor: 'danger',
      title: 'Une erreur est survenue, merci de réessayer !'
    };
    showModal(modalData);
  }
  component.setState({ isLoadingReception: false });
};

const currentHours = component => {
  const { hours = {} } = component.props.shop;
  const currentDate = new Date();
  let hour = '';
  Object.keys(hours).forEach(day => {
    if (day.slice(0, 3) === currentDate.toString().slice(0, 3)) {
      hour = hours[day].slots;
    }
  });
  return hour;
};
export const clearIntervalSong = () => {
  clearInterval(setIntervalSong);
};
export const returnNumber = num => {
  let result = '';
  if (num.length < 11) {
    for (let i = 0; i < 5; i++) {
      result = `${result} ${num.substring(0, 2)}`;
      num = num.substring(2);
    }
  } else {
    result = num;
  }
  return result;
};
export const isDelivery = orderType => {
  return orderType === ORDER_TYPE_DELIVERY || orderType === '';
};

export function formatPhone(phone, countryCode = '+33') {
  if ((isStringNotNull(phone)) && !phone.startsWith('0') && !ensureCleanPhoneNb(phone).startsWith(countryCode.replace(/(^\d)/, '+$1'))) {
    phone = '0' + phone
  }
  return ensureCleanPhoneNb(phone);
}

export function ensureCleanPhoneNb(num, prefix = '+33') {

  return (isStringNotNull(num)) ? num
    .replace(/\D/g, '') // delete everything but digits
    .replace(/^0/, prefix) // replace leading 0 by the prefix
    .replace(/(^\d)/, '+$1') : num // add the + sign if not exist
}
export const handleLunchDelivery = async (order, component) => {
  const { openErrorModal } = component.props;
  component.setState({ isLoadingReception: true });
  try {
    await lunchDelivery(order);
  } catch (error) {
    openErrorModal(
      "Une erreur s'est produite lors de l'envoi de la livraison. Le client pourrait être en train de modifier ou d'annuler sa commande. Veuillez réessayer dans un moment."
    );
  }
  component.setState({ isLoadingReception: false });
};

export const handleAcceptDelivery = async (order, component) => {
  const { openErrorModal } = component.props;
  component.setState({ isLoadingReception: true });
  try {
    await acceptDelivery(order);
  } catch (error) {
    openErrorModal(
      "Une erreur s'est produite lors de l'acceptation de la livraison. Le client pourrait être en train de modifier ou d'annuler sa commande. Veuillez réessayer plus tard."
    );
  }
  component.setState({ isLoadingReception: false });
};
export const getSortedDrivers = (driversHistory) => {
  return _.flatMap(driversHistory, (driver) =>
    _.map(driver.dates, (date) => ({
      date,
      method: driver.method,
      name: driver.name,
    }))
  ).sort((a, b) => moment(b.date).valueOf() - moment(a.date).valueOf());
};
export const getTrackingUrl = (order) => {
  for (const provider of EXTERNAL_DELIVERY_PROVIDERS) {
    if (order[provider]?.trackingUrl) {
      return order[provider].trackingUrl;
    }
  }
  return null;
};

export const isAnyProviderEnabled = (order) => {
  return EXTERNAL_DELIVERY_PROVIDERS.some(provider => order[provider]?.enabled);
};
export const formatCategoryName = ({ shopCategory, parentItemLabel, parentItemRecursiveKey, isMultiple }) => {
  const counter = getCounterFromItemRecursiveKey(parentItemRecursiveKey);
  const categoryCounterName = counter && isMultiple ? ` N°${counter}` : '';
  const parentItemNamePrefix = `${parentItemLabel}${categoryCounterName} - `;
  return shopCategory.name.includes(parentItemNamePrefix)
    ? shopCategory.name
    : `${parentItemNamePrefix}${shopCategory.originalName || shopCategory.name}`;
};

export const findOptionParent = (option, items) => {
  const { categoryKey: optionKey } = option;
  const lastOptionKey = _.last(optionKey.split(ITEM_KEY_CATEGORY_SEPARATOR));

  let foundOptionParent = null;
  _.forEach(items, (category) => {
    if (!foundOptionParent && category?.options) {
      foundOptionParent = findParentInCategoryOptions(category.options, optionKey, lastOptionKey);
      if (foundOptionParent) {
        foundOptionParent = {
          ...foundOptionParent,
          categoryMultiple: category.categoryMultiple,
        };
      }
    }
  });

  return foundOptionParent;
};
const findParentInCategoryOptions = (options, optionKey, lastOptionKey) => {
  return _.find(options, (option) => {
    if (option.subcategories) {
      const lastItemRecursiveKey = _.last(option.itemRecursiveKey.split(ITEM_KEY_CATEGORY_SEPARATOR));
      return (
        option.subcategories.includes(lastOptionKey) &&
        optionKey.includes(lastItemRecursiveKey)
      );
    }
    return false;
  });
};
export const getCounterFromItemRecursiveKey = (itemRecursiveKey) => {
  if (!itemRecursiveKey?.includes(ITEM_KEY_COUNTER_SEPARATOR)) {
    return null;
  }
  const cutKey = itemRecursiveKey.split(ITEM_KEY_COUNTER_SEPARATOR);
  return cutKey[cutKey.length - 1];
};
export const getCancellationReason = (order) => {
  if (!order || !order.cancellation) return null;

  if (order?.statusLabel === ORDER_CANCELED_LABEL) {
    return order.cancellation.canceledBy;
  }
};
export const getDeliveryLogo = (deliveryNature) => {
  if (!deliveryNature) return fleet;

  const nature = deliveryNature.toUpperCase();

  const logoMap = {
    [STUART]: stuartLogo,
    [UBER]: uberDirectLogo,
    [DELIVEROO]: delivero,
  };

  return logoMap[nature] || fleet;
};
export const hasExternalActiveJobId = (order) => {
  if (!order) return false;

  const { deliveroo, uberDirect, stuart } = order;

  return (
    deliveroo?.jobId ||
    uberDirect?.jobId ||
    stuart?.jobId
  );
};
export const shouldDisplayScheduledMessage = (currentOrder) => {
  if (!currentOrder) return false;

  const {
    isSchedule,
    initialOrderDeliveryRequestedDate,
    delivery,
    orderType
  } = currentOrder;


  return (
    isSchedule === true &&
    (!hasExternalActiveJobId(currentOrder) && !delivery?.jobId) &&
    !delivery?.searchDriver &&
    !initialOrderDeliveryRequestedDate &&
    isDelivery(orderType)
  );
};
export const shouldDisplaySearchingDriverSection = (order, statusLabel, component) => {
  const isReverseLookingDriver =
    order?.orderFlowType === ORDER_FLOW_TYPE.REVERSE &&
    statusLabel === ORDER_PHASE_LOOKING_FOR_DRIVER_LABEL &&
    shouldDisplayAcceptDelivery(order);
  const isPreparingUnsupported =
    order?.pickupStatus === PICKUP_STATUS_KEY.ORDER_NOT_CURRENTLY_SUPPORTED &&
    (statusLabel === ORDER_PHASE_PREPARING_LABEL) &&
    (!shouldDisplayScheduledMessage(order) || !component.props.showOrderInPreparation) &&
    isDelivery(order?.orderType);

  return isReverseLookingDriver || isPreparingUnsupported;
};
export const getPaperClassName = (order, statusLabel, classes, isDisplayDriverDetails, component) => {
  const isReverseFlowSearchingDriver =
    order?.orderFlowType === ORDER_FLOW_TYPE.REVERSE &&
    statusLabel === ORDER_PHASE_LOOKING_FOR_DRIVER_LABEL &&
    order?.delivery?.searchDriver;

  const isPreparingOrLookingDriverWithPickupNotSupported =
    (statusLabel === ORDER_PHASE_PREPARING_LABEL ||
      statusLabel === ORDER_PHASE_LOOKING_FOR_DRIVER_LABEL) &&
    (!shouldDisplayScheduledMessage(order) || (statusLabel === ORDER_PHASE_PREPARING_LABEL && !component.props.showOrderInPreparation)) &&
    isDelivery(order?.orderType) &&
    order?.pickupStatus === PICKUP_STATUS_KEY.ORDER_NOT_CURRENTLY_SUPPORTED;

  if (isDisplayDriverDetails && order?.userNameDep) {
    return classes.deliverySecondSectionStyle;
  }

  if (isReverseFlowSearchingDriver || isPreparingOrLookingDriverWithPickupNotSupported) {
    return classes.lookingDriverStyle;
  }

  return classes.paperStyle;
};
export const shouldDisplayAcceptDelivery = (currentOrder) => {
  if (!currentOrder) return false;

  const { selfPickupEligible, deliveryAcceptableByShop } = currentOrder;

  return (
    (selfPickupEligible || deliveryAcceptableByShop) && !hasExternalActiveJobId(currentOrder)
  );
};
export const getSendToPOSDate = (order) => {
  const openTimerSendToPOS = getOpenTimerSendToPOS(order.shopId)
  if (!order?.initialOrderDate) return null;
  const date = subtractFromDate(order.initialOrderDate, openTimerSendToPOS, 'minutes')
  return `${displayDate(date, false)} ${suitableTime(date)}`
}
export const getSplashStatus = (order) => {
  const isWaitingPOS = !order?.hasOwnProperty(ORDER_SYNCH_TOPOS);
  return {
    showMessage: !order?.sendingToPOS && isWaitingPOS,
    showSpinner: order?.sendingToPOS && isWaitingPOS,
  };
}
export const getSplashOrderCondition = (currentOrder) => {
  const isSplash = hasExternalIntegration(currentOrder?.shopId) === SPLASH;
  const splashStatus = getSplashStatus(currentOrder);
  const shouldShowMessageOrSpinner = splashStatus.showMessage || splashStatus.showSpinner;
  return isSplash && shouldShowMessageOrSpinner;

}